/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LanguageIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5klEQVR4nM1Uv2sUURC+C1qYImJhL3aBVEmRLgdqcXD7ZmYvvpu503o7QRArhbMSrkqRJgTSxUa4PyBFmqgEBCGBQJIiQTvRRgsjJ/5idue8JUS9fUfgBgZ237z3fd/8eK9UGgdzJK8A+cW5EQDJL/XRVRpQYcchstNNoQSOZCskqfJZi7W4MZOCohyWQi3CJjmUHsTsT8ccyj1T/SyYQIGttkdJklzsr7fb7Qkg3ktjIHEwgYIC8lsrxYPT6oHkXZ44LAsQMILvETYXARq3APmrriE2ne6p1VvXHXGiXq3emSpOQtwxkp5DOcnU89IgI14dTBInIYmU8/fDkRxUKpULGoiiaNKhfHLIP7J+yXYhZAVyxCsG/tMhfzOgbqqe5G7/H0iO9ZuIp4cC995fBpQNK88JgNwGaCwAygcg/phOE/KmlaYOyE+tfJ2hCADltR14DyDz/fVarXWl6v1VRL6WlYY/e+8vqfL+/qGmC1BeAsobBTor7pCfZNnxWu7MjmUUlUa0sl5ABYuQb/4hIH6Y71GwuVhuDF5R6QLK88ytJyg9LWM4Acr6f19XlPtB4F6ni+RLChSzJ2rN5R1IHluzd8PUEyf2CO7/VYA9J1HcmC1MACjbpvDRP/boxdP+LBcmGEv7DUP1RJtCF+sRAAAAAElFTkSuQmCC)
 */
export const LanguageIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11 2a1 1 0 1 0-2 0v1H3a1 1 0 0 0 0 2h9.94a8.04 8.04 0 0 1-2.76 5.11l-.14.12-.2-.16a7.9 7.9 0 0 1-2.38-3.4 1 1 0 1 0-1.88.67 9.9 9.9 0 0 0 2.92 4.21l-3.15 2.69a1 1 0 0 0 1.3 1.52l3.4-2.91 1.31 1.08a1 1 0 1 0 1.28-1.53l-1.04-.87c1.9-1.68 3.1-4.02 3.35-6.53H17a1 1 0 1 0 0-2h-6V2Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M22.77 22H20.5l-.99-2.77H14.3L13.3 22h-2.27l4.72-12.42h2.3L22.77 22ZM16.9 11.87l-1.92 5.43h3.85l-1.93-5.43Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
